/* eslint-disable no-console */
<template>
  <div>
    <div class="card z-depth-5 p-3">
      <h4 class="text-center font-weight-bold py-3">Edit Account</h4>
      <div>
        <!-- Default form login -->
        <form class="border border-light p-5">
          <div class="row">
              <div class="form-group col-md-12">
                  <label>Username</label>
                  <input ref="username" class="form-control mb-4" placeholder="Username"
                  :value="admin.username" disabled>
              </div>
          </div>
          <div class="row">
              <div class="form-group col-md-12">
                  <label>Permissions</label>
                  <multiselect v-model="permissions" tag-placeholder="" placeholder="Search a tag" label="name" track-by="code" :options="permissionList" :multiple="true" :taggable="true"></multiselect>
              </div>
          </div>

          <!-- Sign in button -->
          <button class="btn btn-info btn-block my-4" @click.prevent="updateAdmin()">
            Update Account
          </button>
        </form>
        <!-- Default form login -->
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "AddAdmin",
  components: {},
  data() {
    return {
      user_id: this.$route.params.user_id,
      fastAdminToken: localStorage.getItem("fastAdminToken"),
      permissions: [
            ],
            permissionList: [
                { name: 'Message', code: 'Message' },
                { name: 'Levels', code: 'Levels' },
                { name: 'Groups', code: 'Groups' },
                { name: 'Plans', code: 'Plans' },
                { name: 'Teachers', code: 'Teachers' },
                { name: 'Admins', code: 'Admins' },
                { name: 'Students', code: 'Students' },
                { name: 'Pending Students', code: 'PendingStudents' },
                { name: 'Transactions', code: 'Transactions' },
                { name: 'Homeworks', code: 'Homeworks' },
                { name: 'Report', code: 'Report' },
            ],
      admin: []
    };
  },
  methods: {
    updateAdmin() {
      let permissions = [];
        for (var i in this.permissions) {
            permissions.push(this.permissions[i].name);
        }
        permissions.push('Dashboard');
        let data = {
          permissions
        };
        const config = {
          headers: {
            Authorization: "Bearer " + this.admin.token,
            "Content-Type": "application/json",
          },
        };
        this.$toast.open({
          message: "Processing : Updating Teacher Please Wait...",
          type: "info",
        });
        axios
          .post(this.$apiURI + "/account/update", data, config)

          .then((response) => {
            if (response.data.error) {
              this.$toast.open({
                message: "Error : " + response.data.message,
                type: "error",
              });
            } else {
              this.$toast.open({
                message: "Admin Updated Successfully",
                type: "success",
              });
            }
          })
          .catch((error) => {
            this.$toast.open({
              message: "Error : " + error.response.data.message,
              type: "error",
            });
          });
    },
  },
  mounted() {
    this.$toast.open({
      message: "Processing : Loading Plan Please Wait...",
      type: "info",
    });

    const config = {
      headers: {
        Authorization: "Bearer " + this.fastAdminToken,
        "Content-Type": "application/json",
      },
    };
    axios
      .get(this.$apiURI + "/account/clone/" + this.user_id, config)
      .then((response) => {
        if (response.data.error) {
          this.$toast.open({
            message: "Error : " + response.data.message,
            type: "error",
          });
        } else {
          // eslint-disable-next-line no-console
          // console.log(response.data.data.teachers)
          this.admin = response.data.data;
          for (var i in this.admin.permissions) {
            if (this.admin.permissions[i] == 'Dashboard') continue;
            this.permissions.push(
              {
                name: this.admin.permissions[i],
                code: this.admin.permissions[i],
              }
            );
          }
          // this.planTarget = response.data.data.target
        }
      })
      .catch((error) => {
        this.$toast.open({
          message: "Error : " + error.response.data.message,
          type: "error",
        });
      });
  },
};
</script>
